import React from 'react';
import { Carousel } from 'antd';
import './index.less';
import ABSIcon from '../ABSIcon';

export interface IABSCarouselProps {
  autoplay?: boolean;
  autoplaySpeed?: number;
}

class ABSCarousel extends React.Component<IABSCarouselProps> {
  static defaultProps = {
    autoplay: true
  };

  render() {
    const { autoplay, children, autoplaySpeed } = this.props;
    return (
      <div className="abs-carousel">
        <Carousel
          arrows={true}
          prevArrow={
            <span>
              <ABSIcon type="direction-left" size={16} />
            </span>
          }
          nextArrow={
            <span>
              <ABSIcon type="direction-right" size={16} />
            </span>
          }
          autoplay={autoplay}
          autoplaySpeed={autoplaySpeed}
        >
          {children}
        </Carousel>
      </div>
    );
  }
}

export default ABSCarousel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSCarousel/index.tsx